export default "__VITE_ASSET__e_pENZE1__"